import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'antd';

import { resetCompanySearch } from 'store/entities/company';
import useLastPathname from 'hooks/navigation/useLastPathname';
import IndividualSearch from 'views/Search/IndividualSearch';
import CompanySearch from 'views/Search/CompanySearch';
import ForeignCompanySearch from 'views/Search/ForeignCompanySearch';
import LoadingSpinner from '../../components/reusable/LoadingSpinner';
import UnauthenticatedSearch from './UnauthenticatedSearch';
import UnauthenticatedWrapper from './UnauthenticatedSearch/UnauthenticatedWrapper';

const Search = () => {
  const dispatch = useDispatch();
  const lastPathname = useLastPathname();
  const { isAuthenticated, signInPending, sessionLoading } = useSelector(state => state.user);
  const { getPersonPending } = useSelector(state => state.person);
  const { getCompaniesPending } = useSelector(state => state.company);

  useEffect(() => {
    return () => dispatch(resetCompanySearch());
  }, [dispatch]);

  if (!isAuthenticated && !signInPending && !sessionLoading) {
    return (
      <UnauthenticatedWrapper>
        <UnauthenticatedSearch />
      </UnauthenticatedWrapper>
    );
  }

  return (
    <LoadingSpinner size="large" spinning={getPersonPending || getCompaniesPending}>
      {isAuthenticated && (
        <div>
          <Col span={24}>
            <Row style={{ height: 'auto' }}>
              {lastPathname === 'company' && <CompanySearch />}
              {lastPathname === 'individual' && <IndividualSearch />}
              {lastPathname === 'foreignCompany' && <ForeignCompanySearch />}
            </Row>
          </Col>
        </div>
      )}
    </LoadingSpinner>
  );
};

export default Search;
